import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { SignupPage } from '#features/auth/signup-page'

export const Route = createFileRoute('/_auth/signup')({
  validateSearch: z.object({
    invite_code: z.string().optional(),
  }),
  head: () => ({
    meta: [
      {
        title: 'Signup',
      },
    ],
  }),
  component: SignupPage,
})
